// third-party
import { Trans } from 'react-i18next';

// assets
import { IconBinaryTree,IconReceiptTax, IconChartPie } from '@tabler/icons';
import { OverrideIcon } from 'types';

// constant
const icons = {
    IconBinaryTree,
    IconReceiptTax,
    IconChartPie,
};

// ==============================|| DASHBOARD MENU ITEMS ||============================== //

interface listSupplierStaffsMenuProps {
    id: string;
    title: React.ReactNode | string;
    type: string;
    children: {
        id: string;
        title: React.ReactNode | string;
        type: string;
        url: string;
        icon: OverrideIcon;
        breadcrumbs: boolean;
    }[];
}
const SupplierStaffs: listSupplierStaffsMenuProps = {
    id: 'supplier-staffs',
    title: <Trans i18nKey="Supplier" id="Supplier" />,
    type: 'group',
    children: [
        {
            id: 'supplier-staffs',
            title: <Trans i18nKey="Supplier Staffs" id="Supplier Staffs" />,
            type: 'item',
            url: '/supplier-staffs',
            icon: icons.IconBinaryTree,
            breadcrumbs: false
        },
        {
            id: 'supplier-staffs-checkin',
            title: <Trans i18nKey="Checkin" id="Checkin" />,
            type: 'item',
            url: '/supplier-staffs-checkin',
            icon: icons.IconReceiptTax,
            breadcrumbs: false
        },
        {
            id: 'supplier-staffs-statistics',
            title: <Trans i18nKey="Statistics" id="Statistics" />,
            type: 'item',
            url: '/supplier-staffs-statistics',
            icon: icons.IconChartPie,
            breadcrumbs: false
        },
    ]
};

export default SupplierStaffs;
